import { render } from "./FormulairesStep5.vue?vue&type=template&id=50d1542a&scoped=true"
import script from "./FormulairesStep5.vue?vue&type=script&lang=js"
export * from "./FormulairesStep5.vue?vue&type=script&lang=js"

import "./FormulairesStep5.vue?vue&type=style&index=0&id=50d1542a&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d1542a"]])

export default __exports__